import React, { useState } from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const ShareModal = ({ mood, isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);

  const shareText = mood ? `The world is feeling ${mood.adjective?.toUpperCase()} right now! Check out the global mood: ` : '';
  const shareUrl = window.location.href;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareText + shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`, '_blank');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="apple-card border-0 max-w-md modal-mobile-optimized modal-glow"
        style={{
          '--modal-glow-color': 'rgba(100,180,255,0.2)',
          '--modal-glow-color-faded': 'rgba(100,180,255,0.08)',
          '--modal-glow-color-dim': 'rgba(100,180,255,0.04)',
        }}
      >
        <DialogHeader>
          <DialogTitle className="apple-headline flex items-center gap-2">
            <Share2 size={20} />
            Share the Mood
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-4 rounded-xl" style={{ background: 'var(--apple-bg-secondary)' }}>
            <p className="text-sm" style={{ color: 'var(--apple-text-secondary)' }}>
              {shareText}
            </p>
          </div>
          <div className="flex gap-2">
            <button 
              onClick={handleCopy}
              className="apple-button flex-1"
              data-testid="copy-share-btn"
            >
              {copied ? <Check size={16} className="inline mr-2" /> : <Copy size={16} className="inline mr-2" />}
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
            <button 
              onClick={handleTwitterShare}
              className="apple-button apple-button-primary flex-1"
              data-testid="twitter-share-btn"
            >
              Share on X
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
